import BordStatus from 'components/NudosComponents/BordStatus/BordStatus';
import BordOneToneIcon from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon';

import './PendingActionStatus.scss';

interface IPendingActionStatusProps {
  status: string;
  actionText: string;
  onClick: () => void;
}

enum PendingActionStatusText {
  PENDING_STATEMENT_ENROLLMENT = 'Estado del Enrollment pendiente por confirmar'
}

const PendingActionStatus = ({ status, actionText, onClick }: IPendingActionStatusProps) => {
  return (
    <BordStatus
      variant="alert"
      showArrow={false}
      showCircleStatus={false}
      customClassName="pendingActionStatus"
      renderJSX={
        <div className="pendingActionStatusContainer" onClick={onClick}>
          <div className="pendingActionStatusContent">
            <BordOneToneIcon variant="alertTriangleWarning" standardSize={14} stroke="#F5DD28" customWidth="14px" />
            <span className="pendingActionStatusText">{status}</span>
          </div>
          <div className="divider" />
          <span>
            {actionText === PendingActionStatusText.PENDING_STATEMENT_ENROLLMENT ? (
              <span>Pendiente por confirmar</span>
            ) : (
              <span>{actionText}</span>
            )}
          </span>
        </div>
      }
    />
  );
};

export default PendingActionStatus;
